import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";

import { ProvidersQueryKeys } from "./providersQueryKeys";
import {
  getProviders,
  GetProvidersFilters,
} from "@/api/providers/getProviders";

type Filters = Omit<GetProvidersFilters, "lang">;

export const useProviders = (filters: Filters) => {
  const locale = useLocale();

  return useQuery({
    queryKey: [ProvidersQueryKeys.Providers, locale, filters],
    queryFn: ({ signal }) => {
      const params = { lang: locale, ...filters };
      return getProviders({ signal, params });
    },
  });
};
